var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.616 3.702C35.188 1.278 31.22 0 27.14 0H11v39.953h16.141c3.169 0 6.322-.76 9.122-2.212a20.187 20.187 0 0 0 6.917-5.89A19.781 19.781 0 0 0 47.094 20a19.995 19.995 0 0 0-8.478-16.298z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A72BA",
    d: "M38.859 20c0 2.243-.635 4.337-1.734 6.125l4.793 4.793A18.244 18.244 0 0 0 45.518 20c0-6.204-3.09-11.686-7.804-15.02l-4.816 4.824c3.553 2.008 5.96 5.827 5.96 10.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5C029",
    d: "M19.282 8.314h.032l-6.745-6.745v28.556l6.713-6.713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40B75F",
    d: "M37.125 26.125c-2.062 3.35-5.764 5.593-9.984 5.593-.572 0-5.678-.008-7.859-.032v-8.274l-6.713 6.713v8.251H27.14c6.047 0 11.428-2.94 14.777-7.466l-4.793-4.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E02834",
    d: "M27.141 8.282c2.094 0 4.055.557 5.757 1.514l4.816-4.816C34.718 2.87 31.07 1.57 27.14 1.57H12.57l6.745 6.745c2.196-.024 7.262-.032 7.827-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4B627",
    d: "M22.82 10.831v18.29l12.094-8.619a.638.638 0 0 0 0-1.043L22.82 10.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5C029",
    d: "M22.82 10.831v18.29l10.556-9.897a.585.585 0 0 0-.062-.91L22.82 10.83z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.e499d7ae.svg";
export { ForwardRef as ReactComponent };